
import CartService from '../services/cart.service.js';

const cartService = new CartService();

/**
 * Mutation Consts
 */
const SET_DATA = 'SET_DATA';
const OPEN_SIDECART = 'OPEN_SIDECART';
const CLOSE_SIDECART = 'CLOSE_SIDECART';
const SET_NOTE = 'SET_NOTE';
const SET_ATTRIBUTE = 'SET_ATTRIBUTE';

// STATE
const baseState = {
  token: '',
  note: null,
  attributes: {},
  total_price: 0,
  total_weight: 0,
  item_count: 0,
  items: [],
  requires_shipping: false,
  currency: '',
  sidecartOpen: false
}

const mutations = {
  /**
  Note this should be a one to one representation of the cart JSON for help see
  https://help.shopify.com/en/themes/development/getting-started/using-ajax-api#get-cart
  */
  SET_DATA (state, data) {
    state.token = data.token;
    state.note = data.note;
    state.attributes = data.attributes;
    state.total_price = data. total_price;
    state.total_weight = data.total_weight;
    state.item_count = data.item_count;
    state.items = data.items;
    state.requires_shipping = data.requires_shipping;
    state.currency = data.currency;
    state.discounts = data.cart_level_discount_applications;
  },
  CLOSE_SIDECART(state) {
    state.sidecartOpen = false;
  },
  OPEN_SIDECART(state) {
    state.sidecartOpen = true;
  },
  SET_NOTE(state, note) {
    state.note = note;
  },
};

const actions = {
  init ({ commit }) {
    cartService.getCartData().then((resp) => {
      commit(SET_DATA, resp);
    });
  },
  /** CHANGE ITEM IN CART
  * @param { number } qty
  * @param { number } variant_id
  * @param { properties object } properties
  */
  addItem ({ state, commit, dispatch }, { quantity,id,properties = {} }) {
    cartService.addItem(quantity, id, properties)
    .then((data) => {
      commit(SET_DATA, data)
    });
  },
  updateItem ({ state, commit }, { key, quantity }) {
    cartService.updateItem(quantity, key)
    .then((data) => {
      const itemToUpdate = state.items.find((item) => item.key === key);

      commit(SET_DATA, data);

      if (quantity === 0) {
        // eslint-disable-next-line no-undef
        datalayerRemoveItem(itemToUpdate)
      }
    });
  },
  removeItem({ commit }, key) {
    const quantity = 0;
    cartService.updateItem(quantity, key)
    .then((data) => commit(SET_DATA, data));
  },
  openSidecart({ commit }){
    console.log('hit')
    commit(OPEN_SIDECART);
  },
  closeSidecart({ commit }){
    commit(CLOSE_SIDECART);
  },
  updateNote({ commit }, note) {
    cartService.updateCart({ note })
    .then((data) => commit(SET_DATA, data))
  },
  updateAttributes({ commit }, attributes) {
    cartService.updateCart(attributes)
    .then((data) => commit(SET_DATA, data))
  }
}

export default { namespaced: true, state: baseState, mutations, actions };
